import type { Me } from "../api";

/**
 * Shown when a SIGNED-IN, non-operator account hits the /operator deep link. The operator plane is
 * role-based: an account either has the operator role (and is already on the platform plane) or it
 * does not — there is no key to enter. Access is granted per account (the first operator via the CLI
 * `amendie-admin grant-operator`, the rest by an existing operator). So this is a plain "no access"
 * notice, not a prompt.
 */
export function NoOperatorAccess({ me, onDismiss }: { me: Me; onDismiss: () => void }) {
  return (
    <div className="gate">
      <div className="gate-card">
        <div className="brand big">
          Amendie <span className="muted">operator</span>
        </div>
        <p className="muted">
          You're signed in as <strong>{me.email ?? "this account"}</strong>, which doesn't have
          operator access. Operator access is granted per account — ask an existing operator to grant
          yours.
        </p>
        <button className="btn" onClick={onDismiss}>
          Go to dashboard
        </button>
      </div>
    </div>
  );
}
